import React, {PureComponent} from "react";
import PropTypes from "prop-types";

export default class RingSizeExplainer extends PureComponent {
  static propTypes = {
    "clickHandler": PropTypes.func.isRequired,
    "open": PropTypes.bool.isRequired
  };

  toggleClass = () => {
    const {open} = this.props;

    return open ? "ring-size-explainer-enter" : "ring-size-explainer-exit";
  }

  render () {
    const {clickHandler} = this.props;
    const imageUrlPrefix = "https://karat-herokuapp-com.freetls.fastly.net/s3media";

    return (
      <div className={`RingSizeExplainer ring-size-explainer ${this.toggleClass()}`}>
        <div id="ring-size-modal">
          <div className="flex-end">
            <a
              className="ma16 close-icon"
              href="#"
              onClick={clickHandler}
            />
          </div>

          <h4>
            HOW TO MEASURE
          </h4>

          <div>
            <img
              alt="mark-finger-length"
              className="mb16"
              src={`${imageUrlPrefix}/style_survey/ring_size_explainer/illustration-hand.png`}
            />
            <div className="step-number">
              1
            </div>
            <p className="mb16">
              Use a string or piece of paper to mark the length around your finger.
            </p>
          </div>

          <div>
            <img
              alt="measure-your-finger"
              className="mb16"
              src={`${imageUrlPrefix}/style_survey/ring_size_explainer/illustration-measure.png`}
            />
            <div className="step-number">
              2
            </div>
            <p className="mb16">
              Measure the length between the 2 points.
            </p>
          </div>

          <div>
            <img
              alt="use-size-chart"
              className="mb16"
              src={`${imageUrlPrefix}/style_survey/ring_size_explainer/size-chart.png`}
            />
            <div className="step-number">
              3
            </div>
            <p className="pb32">
              Compare with our size chart.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
